import React, { Component, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import MaskedInput from "react-text-mask";
import axios from "axios"
import { isEmpty, map } from "lodash";
import { addProject, getProjectUUIDAction, projectUpdate } from "../../../store/projects/actions"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { BlobServiceClient } from '@azure/storage-blob';
import moment from "moment-timezone";
import {
  Row,
  Col,
  CardBody,
  Card,
  CardText,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import CurrencyDropdown from "components/dropdowns/Other/CurrencyDropdowns";
import SaveButton from "components/buttons/save";
import ProjectStatusOption from "components/dropdowns/project/ProjectStatus";
import CurrencyInput from "react-currency-input-field";
import { API_URL } from "helpers/app_url";
import SafeField from "helpers/SafeField";


class ProjectUpdate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      projectTypes: [],
      builders: [],
      projectStatus: [],
      file: null,
      selectedCurrency: {
        code: 'USD', 
        symbol: '$', 
        format: 'USD', 
      },
    }
    this.handleProjectSubmit = this.handleProjectSubmit.bind(this)
  }
   handleProjectSubmit(value) {
    this.props.addProject(value, this.props.history);
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
  handleCurrencyChange = (currencyDetails) => {
    this.setState({
        selectedCurrency: currencyDetails
    });
};
 
  async handleFileChange(event, setFieldValue) {
    const file = event.currentTarget.files[0];
    if (file) {
      const sasToken = "sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2025-06-22T02:18:02Z&st=2024-06-21T18:18:02Z&spr=https,http&sig=Srg7JmJ7EfJQWUNadO188IgXNeCFEzSmQQmctuyjGxA%3D";
      const containerName = "images";
      const storageAccountName = "realtyspace";
      const fileName = `${Date.now()}_${file.name}`;
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      try {
        await blobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type }
        });

        //alert('File uploaded successfully!');
        if (setFieldValue) {
          const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
          setFieldValue(`projectLogoLink`, fileUrl);
        }
      } catch (error) {
        console.error('Error uploading file:', error);

      }
    }
  }

  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };

  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
    
      axios.get(`${API_URL}BuilderExt/allforagent`, {
        params: {
          agentId: parseInt(localStorage.getItem('userId'))
        }, headers: { Authorization: str }
      })
        .then(res => {
          const builders = res.data;
          this.setState({ builders });
        }),
        axios.get(`${API_URL}ProjectType/allforagent`, { 
          params: {
            agentId: parseInt(localStorage.getItem('userId'))
          },    headers: { Authorization: str }
         })
          .then(res => {
            const projectTypes = res.data;
            this.setState({ projectTypes });
          })
      
  }
  render() {
   return (

      <React.Fragment>
          <Formik
                        enableReinitialize={true}
                        initialValues={{
                          projectName: (this.state.projectName) ? this.state.projectName : '',
                        
                          projectType: "",
                          projectStatus: "",
                          projectBuilder: "",
                          costPerSqFt: '',
                          fullAddress:'',
                          
                          //projectLogoLink: (this.state.files.name) ?  this.state.files.name : ''

                        }}
                        validationSchema={Yup.object().shape({
                          projectName: Yup.string().required("This is required"),
                          projectType: Yup.string().required("This is required"),
                          projectBuilder: Yup.string().required("This is required"),
                          projectStatus: Yup.string().required("This is required"),
                        
                        })}
                         onSubmit={(values) => {
                           
                            this.props.addProject(values);
                                                                
                                                                
                      }}
                      >
                        {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                             <Row>
                                      <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="projectName">
                                            {this.props.t("Project Name *")}
                                          </Label>
                                          <SafeField
                                            name="projectName"
                                            type="text"
                                            onChange={handleChange}
                                            className={
                                              "form-control" +
                                              (errors.projectName && touched.projectName
                                                ? " is-invalid"
                                                : "")
                                            }
                                          />
                                          <ErrorMessage
                                            name="projectName"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="builderName">
                                            {this.props.t("Builder Name *")}
                                          </Label>
                                          <SafeField as="select" name="projectBuilder"
                                            className={
                                              "form-control" +
                                              (errors.projectBuilder && touched.projectBuilder
                                                ? " is-invalid"
                                                : "")
                                            }
                                            onChange={handleChange}>
                                            <option value="">Select</option>
                                            {
                                              this.state.builders
                                                .map(builder =>
                                                  <option key={builder.id} value={builder.id}>{builder.builderName}</option>
                                                )
                                            }
                                          </SafeField>
                                          <ErrorMessage
                                            name="projectBuilder"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="pType">
                                            {this.props.t("Type *")}
                                          </Label>
                                          <SafeField as="select" name="projectType"
                                            className={
                                              "form-control" +
                                              (errors.projectType && touched.projectType
                                                ? " is-invalid"
                                                : "")
                                            }
                                            onChange={handleChange}>
                                            <option value="">Select</option>
                                            {
                                              this.state.projectTypes
                                                .map(projectType =>
                                                  <option key={projectType.id} value={projectType.id}>{projectType.projectTypeTitle}</option>
                                                )
                                            }
                                          </SafeField>
                                          <ErrorMessage
                                            name="projectType"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="fullAddress">
                                            {this.props.t("Project Location")}
                                          </Label>


                                          <PlacesAutocomplete
                                             value={values.fullAddress}
                                             onChange={(value) => setFieldValue('fullAddress', value)}
                                            onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                          >
                                       {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                  <div>
                                                    <input
                                                      {...getInputProps({
                                                        placeholder: 'Enter Address...',
                                                        className: 'form-control',
                                                      
                                                      })}
                                                    />
                                                    <div className="">
                                                      {loading ? <div>Loading...</div> : null}

                                                      {suggestions.map((suggestion, i) => {
                                                        const className = suggestion.active
                                                          ? 'suggestion-item--active'
                                                          : 'suggestion-item';
                                                        const style = suggestion.active
                                                          ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                          : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                                        return (
                                                          <div
                                                          key={i}
                                                            {...getSuggestionItemProps(suggestion, {
                                                              style,
                                                            })}
                                                          >
                                                            {suggestion.description}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                )}
                                              </PlacesAutocomplete>


                                        </FormGroup>
                                      </Col>
                                     
                                      <Col md="12">
                                        <CurrencyDropdown name="projectCurrencyCode" label="Project Currency"
                                        onCurrencyChange={this.handleCurrencyChange}
                                        />
                                        </Col> 
                                        <Col md="12">
                                       <ProjectStatusOption errors={errors} touched={touched} />
                                      </Col>
                                    </Row>
                                    <div>

<SaveButton>Save</SaveButton>



</div>
                          </Form>
                        )}
                      </Formik>
      </React.Fragment>
    )
  }
}

ProjectUpdate.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  apiError: PropTypes.any,
  addProject: PropTypes.func,
  address: PropTypes.any,
  ongetProjectUUIDAction: PropTypes.func,
  match: PropTypes.object,
  projectData: PropTypes.object,
  onUpdateProject: PropTypes.func,
  loading: PropTypes.object,
  onClose: PropTypes.func,

}
const mapStateToProps = ({ Project }) => (
  {
    projectData: Project.projectData,
    loading: Project.loading

  })
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  addProject: (data, history) => dispatch(addProject(data, history)),
  onUpdateProject: (data) => dispatch(projectUpdate(data)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(ProjectUpdate)))